import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { formatNumber } from 'helpers/utils';
import { updateEmployeeExpense } from 'redux/booking/travel/travelBookingSlice';
import { Modal, Button, Alert } from 'components/common';

import { INPUT_CLS as inputClass } from 'helpers/formStyles';
const BookingUpdateExpenseEmployeeModal = ({ showModal, setShowModal, booking }) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const dispatch = useDispatch();
  const employees = booking.employees || [];

  const closeModal = () => setShowModal(false);

  const onSubmit = (data) => {
    const updatedEmployees = employees.map((emp) => ({
      employee_id: emp.employee_id,
      employee_name: data[`name_${emp.id}`],
      amount_currency: data[`amount_currency_${emp.id}`],
      exchange_rate: booking.exchange_rate,
      amount: data[`amount_${emp.id}`],
    }));

    try {
      dispatch(updateEmployeeExpense({ bookingId: booking.id, data: { employees: updatedEmployees } }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Update employee expense"
      size="lg"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="update-expense-emp-form" variant="primary">Save</Button>
        </>
      )}
    >
      <form id="update-expense-emp-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="info" className="tw-mb-3">Expense of employee follow as policy company.</Alert>
        <div className="tw-flex tw-justify-end tw-mb-2 tw-text-sm">
          Exchange rate of trip: 1 USD = <span className="tw-mx-1 tw-font-bold tw-text-blue-700">{formatNumber(booking.exchange_rate)}</span> VND
        </div>

        <div className="tw-overflow-x-auto">
          <table className="tw-w-full tw-text-sm tw-border-collapse">
            <thead>
              <tr className="tw-bg-slate-100 tw-text-left">
                <th className="tw-px-2 tw-py-2">No.</th>
                <th className="tw-px-2 tw-py-2">Employee Name</th>
                <th className="tw-px-2 tw-py-2">Amount currency (USD)</th>
                <th className="tw-px-2 tw-py-2">Amount (VND)</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp.id} className="tw-border-b tw-border-slate-100">
                  <td className="tw-px-2 tw-py-2">{emp.id}</td>
                  <td className="tw-px-2 tw-py-2">
                    <input type="text" defaultValue={emp.employee_name} placeholder="Name" className={inputClass}
                      {...register(`name_${emp.id}`, { required: 'Name must be required' })} />
                    {errors[`name_${emp.id}`] && <span className="tw-text-xs tw-text-red-600">{errors[`name_${emp.id}`].message}</span>}
                  </td>
                  <td className="tw-px-2 tw-py-2">
                    <input defaultValue={emp.amount_currency} placeholder="Amount currency" className={inputClass}
                      {...register(`amount_currency_${emp.id}`, { required: 'Amount currency must be required' })}
                      onChange={(e) => setValue(`amount_${emp.id}`, Number((Number(e.target.value) * booking.exchange_rate).toFixed(2)))} />
                    {errors[`amount_currency_${emp.id}`] && <span className="tw-text-xs tw-text-red-600">{errors[`amount_currency_${emp.id}`].message}</span>}
                  </td>
                  <td className="tw-px-2 tw-py-2">
                    <input defaultValue={emp.amount} placeholder="Amount" className={inputClass}
                      {...register(`amount_${emp.id}`, { required: 'Amount must be required' })} />
                    {errors[`amount_${emp.id}`] && <span className="tw-text-xs tw-text-red-600">{errors[`amount_${emp.id}`].message}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </Modal>
  );
};

BookingUpdateExpenseEmployeeModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  booking: PropTypes.object,
};

export default BookingUpdateExpenseEmployeeModal;
